import React from 'react';
import { ContactForm } from '../components/ContactForm';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="flex flex-col min-h-screen pt-24" data-id="element-268">
      <div className="container mx-auto px-4 md:px-6" data-id="element-269">
        <div className="max-w-5xl mx-auto" data-id="element-270">
          <div className="text-center mb-12" data-id="element-271">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-272">
              Get In Touch
            </h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-273">
              Ready to start your bathroom transformation? Fill out the form
              below or give us a call. We're here to help!
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-274">
            {/* Contact Info Card */}
            <div className="md:col-span-1 space-y-6" data-id="element-275">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 h-full" data-id="element-276">
                <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-277">
                  Contact Info
                </h2>

                <div className="space-y-6" data-id="element-278">
                  <div className="flex items-start gap-4" data-id="element-279">
                    <div className="h-10 w-10 rounded-full bg-[#8BA888]/10 flex items-center justify-center shrink-0 text-[#8BA888]" data-id="element-280">
                      <Phone className="h-5 w-5" data-id="element-281" />
                    </div>
                    <div data-id="element-282">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-283">
                        Phone
                      </p>
                      <a href="tel:5749141522" className="text-lg font-semibold text-gray-900 hover:text-[#7DAF9C] transition-colors" data-id="element-284">
                        (574) 914-1522
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-285">
                    <div className="h-10 w-10 rounded-full bg-[#8BA888]/10 flex items-center justify-center shrink-0 text-[#8BA888]" data-id="element-286">
                      <Mail className="h-5 w-5" data-id="element-287" />
                    </div>
                    <div data-id="element-288">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-289">
                        Email
                      </p>
                      <a href="mailto:info@luckyduckbath.com" className="text-lg font-semibold text-gray-900 hover:text-[#8BA888] transition-colors break-all" data-id="element-290">
                        info@luckyduckbath.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-291">
                    <div className="h-10 w-10 rounded-full bg-[#8BA888]/10 flex items-center justify-center shrink-0 text-[#8BA888]" data-id="element-292">
                      <MapPin className="h-5 w-5" data-id="element-293" />
                    </div>
                    <div data-id="element-294">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-295">
                        Service Area
                      </p>
                      <p className="text-gray-900 font-medium" data-id="element-296">
                        Proudly Serving Northern Indiana
                      </p>
                      <p className="text-sm text-gray-500 mt-1" data-id="element-297">
                        South Bend, Mishawaka, Elkhart, Granger, and surrounding
                        areas.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4" data-id="element-298">
                    <div className="h-10 w-10 rounded-full bg-[#8BA888]/10 flex items-center justify-center shrink-0 text-[#8BA888]" data-id="element-299">
                      <Clock className="h-5 w-5" data-id="element-300" />
                    </div>
                    <div data-id="element-301">
                      <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-302">
                        Hours
                      </p>
                      <p className="text-gray-900" data-id="element-303">Mon - Fri: 8am - 5pm</p>
                      <p className="text-gray-900" data-id="element-304">Sat - Sun: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Form Card */}
            <div className="md:col-span-2" data-id="element-305">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100" data-id="element-306">
                <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-307">
                  Request a Consultation
                </h2>
                <ContactForm data-id="element-308" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}